/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_Start_FreeInputs */

const en_landing_cta_start_free = /** @type {(inputs: Landing_Cta_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Free Today`)
};

const de_landing_cta_start_free = /** @type {(inputs: Landing_Cta_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute kostenlos starten`)
};

const fr_landing_cta_start_free = /** @type {(inputs: Landing_Cta_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer gratuitement aujourd'hui`)
};

const es_landing_cta_start_free = /** @type {(inputs: Landing_Cta_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empiece gratis hoy`)
};

const it_landing_cta_start_free = /** @type {(inputs: Landing_Cta_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia gratis oggi`)
};

const nl_landing_cta_start_free = /** @type {(inputs: Landing_Cta_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin vandaag gratis`)
};

const pl_landing_cta_start_free = /** @type {(inputs: Landing_Cta_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij za darmo już dziś`)
};

const fi_landing_cta_start_free = /** @type {(inputs: Landing_Cta_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita ilmaiseksi tänään`)
};

const da_landing_cta_start_free = /** @type {(inputs: Landing_Cta_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start gratis i dag`)
};

const sv_landing_cta_start_free = /** @type {(inputs: Landing_Cta_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Börja gratis idag`)
};

/**
* | output |
* | --- |
* | "Start Free Today" |
*
* @param {Landing_Cta_Start_FreeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_cta_start_free = /** @type {((inputs?: Landing_Cta_Start_FreeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_Start_FreeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_cta_start_free(inputs)
	if (locale === "fr") return fr_landing_cta_start_free(inputs)
	if (locale === "es") return es_landing_cta_start_free(inputs)
	if (locale === "it") return it_landing_cta_start_free(inputs)
	if (locale === "nl") return nl_landing_cta_start_free(inputs)
	if (locale === "pl") return pl_landing_cta_start_free(inputs)
	if (locale === "fi") return fi_landing_cta_start_free(inputs)
	if (locale === "da") return da_landing_cta_start_free(inputs)
	if (locale === "sv") return sv_landing_cta_start_free(inputs)
	return en_landing_cta_start_free(inputs)
});